import axios from "axios";
import { useEffect } from "react";

import Spinner from "@components/spinner/Fallback-spinner";

import { useSelector, useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toggleSessionBouncer, setCookie } from "@store/reducers/session";

import Tracking from "./tracking";

const Bouncer = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const session = useSelector(state => state.session);

  const dispatchCookie = async () => {
    const { data } = await axios({
      method: "GET",
      baseURL: process.env.REACT_APP_MIDDLEWARE_API_URL,
      url: "/company/session",
      withCredentials: true,
    });
    dispatch(setCookie(data));
  };

  useEffect(() => {
    if (session.bouncing) {
      const privatePath = location.pathname.includes("/app/");
      const cookieExist = document.cookie.indexOf("company-token-exists") !== -1;

      if (cookieExist && !session.cookie.accountId) {
        dispatchCookie();
      }

      if (privatePath && !cookieExist) {
        navigate("/login");
      } else if (!privatePath && cookieExist) {
        navigate("/app/home");
      }

      dispatch(toggleSessionBouncer(false));
    }
  }, [session.bouncing]);

  return (
    <div className={props.className}>
      {
        location.pathname.includes("/app/")
          ? session.cookie.alias
            ? <Tracking>{props.children}</Tracking>
            : <Spinner />
          : props.children
      }
    </div>
  );
};

export default Bouncer;
